require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-graphic-design-website-design-refinements.json") })
        }
      }, "path---services-graphic-design-website-design-refinements");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-graphic-design-website-design-refinements!./.cache/json/services-graphic-design-website-design-refinements.json
// module id = 746
// module chunks = 231608221292675